import { ActivityEventRepository } from "@domain/activity-event/repositories/activity-event.repository";
import { ActivityEventRepositoryService } from "../repositories/activity-event.service";

export const ActivityEventProvider = [
    {
      provide: ActivityEventRepository,
      useClass: ActivityEventRepositoryService,
    },
  ];
  